import SingleSelectCards from './SingleSelectCards';

/**
 * QuickScanStep2Solar — "Heeft u zonnepanelen?"
 * Single-select. No panel-count follow-up — that lives in the optional
 * DeepDive after the demo. Goal: keep it light.
 */
export default function QuickScanStep2Solar({ value, onUpdate, error }) {
  return (
    <div data-testid="qs-step-2" className="space-y-6">
      <div>
        <h2
          className="text-2xl sm:text-3xl font-medium text-white leading-tight"
          style={{ fontFamily: 'Outfit' }}
          data-testid="qs-step-2-headline"
        >
          Heeft u zonnepanelen?
        </h2>
      </div>

      <SingleSelectCards
        label=""
        value={value}
        options={[
          { value: 'yes', label: 'Ja' },
          { value: 'no', label: 'Nee' },
          { value: 'planned', label: 'Binnenkort' },
          { value: 'unknown', label: 'Weet ik niet' },
        ]}
        onChange={onUpdate}
        testIdPrefix="qs-solar"
        error={error}
        columns={2}
      />
    </div>
  );
}
